export default function initToggle() {
    const toggleElem = document.querySelectorAll('[data-toggle-aria]');

    toggleElem.forEach((element) => {
        const ariaControls = element.getAttribute('aria-controls');
        const ariaControlsElement = document.querySelector(`#${ariaControls}`);

        element.addEventListener('click', (event) => {
            event.preventDefault();

            if (ariaControlsElement.getAttribute('aria-hidden') === 'false') {
                element.setAttribute('aria-expanded', false);
                ariaControlsElement.setAttribute('aria-hidden', true);
            } else {
                element.setAttribute('aria-expanded', true);
                ariaControlsElement.setAttribute('aria-hidden', false);

                const focusableElement = ariaControlsElement.querySelector('[aria-focus]');
                if (document.contains(focusableElement)) {
                    focusableElement.focus({ preventScroll: false });
                }
            }
        });
    });
}
